import { captureException } from '@sentry/nextjs';

export interface MastheadHeader {
  navigation: {
    brand: {
      href: string;
      alt: string;
    };
  };
  messageBars?: {
    messageHTML: string;
    options: { type: string };
  }[];
}

export interface MastheadFooter {
  topLinkGroups: {
    links: { title: string; href: string }[];
  }[];
}

export interface MastheadProps {
  masthead: {
    header?: MastheadHeader;
    footer?: MastheadFooter;
  };
}

export const getMasthead = async (market: string) => {
  const MASTHEAD_API = 'https://www.spotify.com/api/masthead/v1/masthead';
  const queryParams = new URLSearchParams({ market });

  try {
    const res = await fetch(`${MASTHEAD_API}?${queryParams}`, { credentials: 'include' });

    if (!res.ok) {
      throw new Error(`Failed to fetch masthead data: ${res.status}`);
    }

    return await res.json();
  } catch (e) {
    captureException(e);
    return {};
  }
};
